module.exports = __webpack_public_path__ + "img/bg.0a2bf38d.jpg";